import './LineCharts.css';

function LineCharts() {
    return ( <
        div className = "svg-lines" >
        <
        svg viewBox = "0 0 529 286"
        xmlns = "http://www.w3.org/2000/svg" >
        <
        g id = "graph-copy"
        stroke = "none"
        strokeWidth = "1"
        fill = "none"
        fillRule = "evenodd"
        transform = "translate(30.000000, 27.000000)" >
        <
        g id = "y_axis"
        fontSize = "11.0833333"
        fontFamily = ".HelveticaNeueDeskInterface-Regular, .Helvetica Neue DeskInterface"
        fill = "#000"
        opacity = "0.4"
        fontWeight = "normal" >
        <
        text id = "0" >
        <
        tspan x = "25.3008249"
        y = "264.333333" > 0 < /tspan> <
        /text> <
        text id = "200" >
        <
        tspan x = "12.7757572"
        y = "232.666667" > 200 < /tspan> <
        /text> <
        text id = "400" >
        <
        tspan x = "12.7757572"
        y = "201" > 400 < /tspan> <
        /text> <
        text id = "600" >
        <
        tspan x = "12.7757572"
        y = "169.333333" > 600 < /tspan> <
        /text> <
        text id = "800" >
        <
        tspan x = "12.7757572"
        y = "137.666667" > 800 < /tspan> <
        /text> <
        text id = "1000" >
        <
        tspan x = "6.51322328"
        y = "106" > 1000 < /tspan> <
        /text> <
        text id = "1200" >
        <
        tspan x = "6.51322328"
        y = "74.3333333" > 1200 < /tspan> <
        /text> <
        text id = "1400" >
        <
        tspan x = "6.51322328"
        y = "42.6666667" > 1400 < /tspan> <
        /text> <
        text id = "1600" >
        <
        tspan x = "6.51322328"
        y = "11" > 1600 < /tspan> <
        /text> <
        /g> <
        g id = "GRAPHS"
        transform = "translate(64.000000, 16.000000)"
        strokeLinecap = "round"
        strokeWidth = "8"
        strokeLinejoin = "round" >
        <
        polyline id = "Banks"
        stroke = "#5BCAC1"
        points = "0 1 88.0438662 1 128.985782 137 180.170616 137 224.189573 182 256.947867 91 301.990521 137 346.009479 91 392.087202 91 429.952607 179" > < /polyline> <
        polyline id = "Bridge"
        stroke = "#81DEFF"
        points = "2.04739336 183 54.2559242 227 96.2274882 47 133.080569 1 302.018438 1 346.680361 44.6280822 386.957346 0 427.905213 43" > < /polyline> <
        polyline id = "PayPal"
        stroke = "#F6F5A6"
        points = "2.04739336 180 53.273159 180 99.2985782 91 137.175355 47 219.077488 47 256.947867 90 301.990521 47 349.080569 137 398.228672 137 432 91" > < /polyline> <
        /g> <
        g id = "x_axis"
        transform = "translate(71.974046, 271.541667)"
        fontSize = "11.0833333"
        fontFamily = ".HelveticaNeueDeskInterface-Regular, .Helvetica Neue DeskInterface"
        fill = "#FFFFFF"
        opacity = "0.4"
        fontWeight = "normal" >
        <
        text id = "1" >
        <
        tspan x = "0.396183206"
        y = "11" > 1 < /tspan> <
        /text> <
        text id = "2" >
        <
        tspan x = "39.2603361"
        y = "11" > 2 < /tspan> <
        /text> <
        text id = "3" >
        <
        tspan x = "78.8786567"
        y = "11" > 3 < /tspan> <
        /text> <
        text id = "4" >
        <
        tspan x = "118.496977"
        y = "11" > 4 < /tspan> <
        /text> <
        text id = "5" >
        <
        tspan x = "158.115298"
        y = "11" > 5 < /tspan> <
        /text> <
        /g> <
        /g> <
        /svg> <
        /div>


    );
}

export default LineCharts